const cookie = require('vue-cookie')

module.exports = function () {
  this.app.$on('logout', event => {
    this.session.destroy()
    this.app.user = null
    this.app.$emit('logoutSuccess')
    cookie.delete('userToken')
  })
}



// WEBPACK FOOTER //
// ./src/events/logout.js